import styles from './mochi-divider.module.sass';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export type MochiDividerProps = React.HTMLAttributes<HTMLDivElement>;

export const MochiDivider = ({ className, ...rest }: MochiDividerProps) => {
  return <div className={cx('divider', className)} {...rest} />;
};
